import { Box, InputLabel, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@mui/icons-material/Search";
import { Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    getFormTitleParam,
    getIsReleasedForm,
    getUserAgent,
    isNotEmpty,
    isObjectNotEmpty,
} from "../../Utils";
import CustomHotlineDialog from "../../component/CustomHotlineDialog/CustomHotlineDialog";
import {
    getApplicantFormList,
    getFormTitleParamList,
    getUserRole,
} from "../../redux/selector";

const useStyles = makeStyles({
    searchContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        border: "1px solid #666",
        borderRadius: "50px",
        width: "300px",
        padding: "1px 10px",
        marginRight: "20px",
        float: "right",
        marginBottom: "20px",
        // marginTop: "-20px",
        /*"& .css-ei7t0p-MuiAutocomplete-root": {
            width: "120px",
        },*/
        "& .MuiInput-underline:before": {
            borderBottom: "none !important",
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important",
        },

        "@media (max-width: 500px)": {
            float: "none",
            width: "90%",
            //marginRight: "10px",
            margin: "0 auto 20px auto",
        },
    },
    searchContainerMobile: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        border: "1px solid #666",
        borderRadius: "50px",
        // width: "280px",
        padding: "1px 10px",
        marginRight: "20px",
        "& .MuiInput-underline:before": {
            borderBottom: "none !important",
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important",
        },

        "@media (max-width: 500px)": {
            width: "90%",
            margin: "0 auto 10px",
        },
    },
});

export default function SearchTemplate() {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const isMobile = isNotEmpty(getUserAgent()) && getUserAgent() !== "Firefox";
    const navigate = useNavigate();
    const role = useSelector(getUserRole());
    const applicantFormList = useSelector(getApplicantFormList());
    const formTitleParam = useSelector(getFormTitleParamList());
    const [navList, setNavList] = useState([]);
    const [formList, setFormList] = useState({});
    const [optionList, setOptionList] = useState({});

    const isPublic = role === "Public";
    const hidePublicOnlyFormList = isPublic ? [] : ["Form015"];

    // Form表单数据
    useEffect(() => {
        let list = applicantFormList
            .filter((item) => getIsReleasedForm(item.url))
            .filter((item) => !hidePublicOnlyFormList.includes(item.url));
        if (list.length > 0) {
            setFormList(list);
        }
    }, [applicantFormList]);

    const filterByRole = (item) => {
        if (role === "SA") {
            if (
                item.id !== 9 &&
                item.id !== 11 &&
                item.id !== 7 &&
                item.id !== 8 &&
                item.id !== 0 &&
                item.id !== 13 &&
                item.id !== 14
            ) {
                return true;
            }
            return false;
        } else if (role === "CH" || role === "SH") {
            if (
                item.id != 0 && //login
                item.id !== 7 && //parameterPage
                item.id !== 10 && //editOrgEdb
                item.id !== 11 && //editReviewerEdb
                item.id !== 12 && //editFormOwner
                item.id !== 9
            ) {
                return true;
            }
            return false;
        } else if (role === "SLA") {
            if (
                item.id != 0 && //login
                item.id !== 7 && //parameterPage
                item.id !== 10 && //editOrgEdb
                item.id !== 11 && //editReviewerEdb
                item.id !== 12 //editFormOwner
            ) {
                return true;
            }
            return false;
        } else if (role === "CLA") {
            if (
                item.id != 0 && //login
                item.id !== 7 && //parameterPage
                item.id !== 10 && //editOrgEdb
                item.id !== 11 && //editReviewerEdb
                item.id !== 12 //editFormOwner
            ) {
                return true;
            }
            return false;
        } else if (role === "FO") {
            if (
                item.id != 0 && //login
                item.id !== 8 &&
                item.id !== 10 && //editReviewerEdb
                item.id !== 12 && //editFormOwner
                item.id !== 9 &&
                item.id !== 13
            ) {
                return true;
            }
            return false;
        } else if (role === "Public" || role === "C" || role === "S") {
            if (
                item.id != 0 && //login
                item.id !== 11 && //editReviewerEdb
                item.id !== 10 && //org
                item.id !== 12 && //editFormOwner
                item.id !== 7 && //parameterPage
                item.id !== 8 && //delegationPage
                item.id !== 9 //staff
            ) {
                return true;
            }
            return false;
        } else if (role === "FR" || role === "E") {
            if (
                item.id != 0 && //login
                item.id !== 11 && //editReviewerEdb
                item.id !== 10 && //org
                item.id !== 12 && //editFormOwner
                item.id !== 7 && //parameterPage
                item.id !== 8 && //delegationPage
                item.id !== 9 && //staff
                item.id !== 13
            ) {
                return true;
            }
            return false;
        } else {
            if (
                item.id !== 11 && //editReviewerEdb
                item.id !== 10 && //org
                item.id !== 12 && //editFormOwner
                item.id !== 7 && //parameterPage
                item.id !== 8 && //delegationPage
                item.id !== 9 &&
                item.id !== 1 &&
                item.id !== 13 &&
                item.id !== 14
            ) {
                return true;
            }
            return false;
        }
    };

    // 菜单数据
    useEffect(() => {
        const sideNavList = [
            {
                id: 0,
                name: "login",
                // component: <ExitToApp />,
                url: "/Login",
            },
            {
                id: 1,
                name: "profilePage",
                // component: <AccountCircle />,
                url: "/ProfilePage",
            },
            {
                id: 7,
                name: "parameterPage",
                // component: <Description />,
                url: "/ParameterPage",
            },
            {
                id: 8,
                name: "delegationPage",
                // component: <People />,
                url: "/DelegationPage",
            },
            {
                id: 9,
                name: "editStaff",
                // component: <AssignmentInd />,
                url: "/EditStaff",
            },
            {
                id: 10,
                name: "editOrgEdb",
                // component: <HomeWork />,
                url: "/EditOrgEdb",
            },
            {
                id: 11,
                name: "editReviewerEdb",
                // component: <AssignmentInd />,
                url: "/EditReviewerEdb",
            },
            {
                id: 12,
                name: "editFormOwner",
                // component: <AssignmentInd />,
                url: "/EditFormOwner",
            },
            {
                id: 13,
                name: "formSelect",
                // component: <ListAlt />,
                url: "/select",
            },
            {
                id: 14,
                name: "formEnquiry",
                // component: <ContactSupport />,
                url: "/FormEnquiry",
            },
        ].filter(filterByRole);

        if (sideNavList.length > 0) {
            setNavList(sideNavList);
            handleOptionData();
        }
    }, [role]);

    useEffect(() => {
        handleOptionData();
    }, [navList, formList]);

    // 获取本地local Fo
    const handleFormData = () => {
        let arr = Object.entries(
            t("form", { returnObjects: true, lng: "en" })
        ).map((r) => {
            return {
                formId: r[0],
                name: t(
                    `form.${r[0]}`,
                    getFormTitleParam(r[0], formTitleParam, i18n.language)
                ),
            };
        });
        return arr;
    };

    const handleOptionData = () => {
        let optionList = [];
        let formObj = handleFormData();
        let data = [...navList];
        let hotline = {
            id: "1100",
            name: "hotline",
            url: "/hotline",
            formId: "hotline",
        };
        if (isObjectNotEmpty(navList) && isObjectNotEmpty(formList)) {
            // 导航菜单数据
            data.forEach((item) => {
                item.id = 1000 + parseInt(item.id);
                item.formId = item.url;
            });

            data.push(hotline);

            // Form数据
            // console.log(intersection(formObj, formList));
            let data1 = intersection(formObj, formList);
            optionList = [...data, ...data1];
            setOptionList(optionList);
        }

        // console.log("optionList---------", optionList);
    };

    const intersection = (nums1, nums2) => {
        return nums1.filter((x) => nums2.some((y) => y.url === x.formId));
    };

    const displaySearchContent = (option) => {
        if (!isObjectNotEmpty(option)) {
            return;
        } else {
            if (isObjectNotEmpty(option.id)) {
                return t(`common.sideNavList.${option.name}`);
            } else {
                return `${option.formId} ${option.name}`;
            }
        }
    };

    const redirect = (url) => {
        navigate(url);
    };

    const [popupFormId, setPopupFormId] = useState(0);

    const handleClose = () => {
        setPopupFormId(0);
    };

    return (
        <>
            <Box
                className={
                    isMobile
                        ? classes.searchContainerMobile
                        : classes.searchContainer
                }
            >
                <SearchIcon color="action" />
                <InputLabel htmlFor="accessibilitySearch" className="hidden">
                    accessibilitySearch
                </InputLabel>
                <Autocomplete
                    // freeSolo
                    fullWidth
                    id="accessibilitySearch"
                    disableClearable
                    options={optionList.length > 0 ? optionList : []}
                    getOptionLabel={(option) => displaySearchContent(option)}
                    noOptionsText={t("common.delegation.emptyResult")}
                    renderInput={(params) => (
                        <>
                            <TextField
                                {...params}
                                placeholder={t("common.searchAccess")}
                                fullWidth={true}
                            />
                        </>
                    )}
                    onChange={(e, val) => {
                        if (val.formId === "hotline") {
                            setPopupFormId(99999);
                        } else {
                            redirect(`/${val.formId}`);
                        }
                    }}
                    onClose={(e) => {
                        if (
                            e.target.innerText ==
                            t("common.sideNavList.hotline")
                        ) {
                            setPopupFormId(99999);
                        }
                    }}
                />

                <CustomHotlineDialog
                    onClose={handleClose}
                    formId={popupFormId}
                    popupHotLineTitle={t(`common.sideNavList.hotline`)}
                />
            </Box>
        </>
    );
}
